import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const EMPTY_PERSON = { name: "", address: "", cap: "", city: "", province: "", phone: "", email: "" };

const FIELDS = [
  ["name", "Nome e cognome *", "sm:col-span-2"],
  ["address", "Indirizzo", "sm:col-span-2"],
  ["cap", "CAP", ""],
  ["city", "Comune", ""],
  ["province", "Provincia", ""],
  ["phone", "Telefono (per gli avvisi InPost)", ""],
  ["email", "Email (per gli avvisi InPost)", "sm:col-span-2"],
];

export function PersonFields({ value, onChange, prefix }) {
  return (
    <div className="grid gap-2 sm:grid-cols-2">
      {FIELDS.map(([k, label, cls]) => (
        <div key={k} className={cls}>
          <Label className="text-xs text-[#CBD5E1]">{label}</Label>
          <Input value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`${prefix}-${k}`} className="bg-[#0B1020] border-[#2A3655]" />
        </div>
      ))}
    </div>
  );
}
